var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "like-2 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.06192 17.3957C5.58908 17.3957 6.01642 16.9684 6.01642 16.4412C6.01642 15.914 5.58908 15.4867 5.06192 15.4867C4.53477 15.4867 4.10742 15.914 4.10742 16.4412C4.10742 16.9684 4.53477 17.3957 5.06192 17.3957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92622 18.7354C8.92622 19.6621 8.17585 20.4125 7.24914 20.4125H2.87435C1.94764 20.4125 1.19727 19.6621 1.19727 18.7354V9.20385C1.19727 8.27714 1.94764 7.52676 2.87435 7.52676H7.24914C8.17585 7.52676 8.92622 8.27714 8.92622 9.20385V18.7354ZM7.48872 18.7354V9.20385C7.48872 9.07064 7.38139 8.96426 7.24914 8.96426H2.87435C2.7421 8.96426 2.63477 9.07064 2.63477 9.20385V18.7354C2.63477 18.8677 2.7421 18.975 2.87435 18.975H7.24914C7.38139 18.975 7.48872 18.8677 7.48872 18.7354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81238 9.58717C8.59771 9.92067 8.15304 10.0184 7.81954 9.80471C7.48508 9.59004 7.38829 9.14537 7.602 8.81092L10.8143 3.80075C11.1996 3.19892 11.812 2.78012 12.5115 2.63925C13.2121 2.49837 13.9395 2.64692 14.5269 3.05229L14.7339 3.19412C15.5255 3.73942 15.9577 4.67187 15.8619 5.62733L15.6031 8.21675C15.5964 8.28479 15.6185 8.35187 15.6635 8.40171C15.7095 8.45154 15.7737 8.48029 15.8418 8.48029H19.1633C19.9645 8.48029 20.7225 8.84542 21.2228 9.47217C21.723 10.098 21.9109 10.9183 21.7326 11.7003L20.2194 18.3617C19.9463 19.5615 18.8797 20.4125 17.6492 20.4125H12.6745C11.7794 20.4125 10.8948 20.2275 10.0755 19.8672L7.91825 18.9213C7.55504 18.7613 7.38925 18.3377 7.54929 17.9745C7.70838 17.6113 8.13292 17.4455 8.49613 17.6046L10.6524 18.5514C11.2897 18.8312 11.9787 18.975 12.6745 18.975H17.6492C18.2088 18.975 18.6928 18.5888 18.8174 18.0425L20.3315 11.3812C20.412 11.0256 20.3268 10.6528 20.0996 10.3682C19.8715 10.0836 19.5275 9.91779 19.1633 9.91779H15.8418C15.3674 9.91779 14.916 9.7175 14.5978 9.36579C14.2797 9.01504 14.1254 8.54546 14.1723 8.07396L14.432 5.48454C14.4752 5.04946 14.2787 4.62587 13.9193 4.37862L13.7123 4.23583C13.445 4.05183 13.1143 3.98379 12.7962 4.048C12.478 4.11221 12.1991 4.30292 12.0238 4.57604L8.81238 9.58717Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeWhite);
export default __webpack_public_path__ + "static/media/like-white.929d696ade4e4fc9ec4bd6056fa89d28.svg";
export { ForwardRef as ReactComponent };